import { Route } from "@angular/router";
import { ValidarVoucherPage } from "./validar-voucher.page";

export const ValidarVoucherRouter: Route[] = [
  { path: 'validar-voucher', component: ValidarVoucherPage }
];
